import axios from "@lib/axios";

export async function getReview(id) {
  const res = await axios.get(`reviews/${id}`);
  return res.data.data;
}

export async function getProductReviews(productId, page, withSharedPictureOnly = false) {
  const res = await axios.get(`products/${productId}/reviews`, {
    params: {
      page,
      with_shared_picture_only: withSharedPictureOnly,
    },
  });
  return res.data;
}

export async function postReview(closetItemId, data) {
  try {
    await axios.post(`closet_items/${closetItemId}/review`, { review: data });
  } catch (err) {
    throw err.response;
  }
}

export async function putReview(reviewId, data) {
  try {
    await axios.put(`reviews/${reviewId}`, { review: data });
  } catch (err) {
    throw err.response;
  }
}

export async function postOrUpdateReview(closetItem, data) {
  if (closetItem.review) {
    return putReview(closetItem.review.id, data);
  } else {
    return postReview(closetItem.id, data);
  }
}
